module.exports = __webpack_public_path__ + "static/media/airbnb-plus-around-the-world.2bdd853a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/airbnb-plus-around-the-world.jpg
// module id = 443
// module chunks = 0